import React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import './src/styles/global.css';
import '@livekit/components-styles';
import UserProvider from './src/context/userContext';
import CartProvider from './src/context/cartContext';
import ProfileProvider from './src/context/profileContext';
import MessagingProvider from './src/context/messageContext';
import ScheduleProvider from './src/context/scheduleContext';
import { LayoutWeb as Layout } from './src/components/Layout';
import { ApolloProvider } from '@apollo/client';
import { client } from './src/apollo/client';
import CheckoutProvider from './src/context/checkoutContext';
// export const registerServiceWorker = () => true;

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => {
  return (
    <ApolloProvider client={client}>
      <UserProvider>
        <ProfileProvider>
          <MessagingProvider>
            <ScheduleProvider>
              <CartProvider>{element}</CartProvider>
            </ScheduleProvider>
          </MessagingProvider>
        </ProfileProvider>
      </UserProvider>
    </ApolloProvider>
  );
};

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
  props,
}) => {
  const path = props.location?.pathname ?? '';
  const isCheckoutFlow = path.startsWith('/cart') || path.startsWith('/checkout');
  return (
    <Layout {...props}>
      {isCheckoutFlow ? (
        <CheckoutProvider>{element}</CheckoutProvider>
      ) : (
        element
      )}
    </Layout>
  );
};
